import * as React from 'react'
import app from '../../config/firebase'

// Import Contact styling
import './Contact.css'

const Contact: React.FunctionComponent = () => {
  // Initialise state for
  const [contact, setContact] = React.useState<string>('')
  const [message, setMessage] = React.useState<string>('')
  // Function to send submission to Firestore
  const submitForm = (e) => {
    e.preventDefault()
    const db = app.firestore()
    // Get date to store in document
    const date = String(new Date().toUTCString())
    db.collection('portfolio-contact')
      .add({
        contact,
        date,
        message
      })
      // Reset state
    setContact('')
    setMessage('')
  }
  return (
    <div className="row blue" id="contact">
      <div className="side-content"></div>
      <div className="main-content">
        <div className="content-header">
          <a className="anchor"></a>
          <h2 className="white-text">Contact Me</h2>
        </div>
        <div className="contact content-body">
          <form onSubmit={submitForm}>
            <input
              type="email"
              placeholder="Your email"
              required
              onChange={e => setContact(e.target.value)}
              value={contact}
            />
            <textarea
              name="message"
              placeholder="Your message"
              onChange={e => setMessage(e.target.value)}
              value={message}
              required
            >
            </textarea>
            <button type="submit">Send</button>
          </form>
        </div>
      </div>
      <div className="side-content"></div>
    </div>
  )
}

export default Contact
